// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"92f81e9b","294":"3a7530e4","721":"057e0e21","749":"92354e97"}[chunkId] + ".chunk.js";
};